// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__krRql","title":"styles_title__5zQSr","text":"styles_text__NNBlW","goHome":"styles_goHome__0cp4q"};